import { Divider, Group, Stack } from "@mantine/core";
import CommunityChooser from "./CommunityChooser";
import { useProfileStore } from "../../../../../stores/UserStore";

const CommunityManager = ({ profile, setProfile, changingProfile }) => {
  return (
    <Stack gap={"xs"}>
      {useProfileStore.getState().profile?.level === "admin" && (
        <CommunityChooser
          changingProfile={changingProfile}
          profile={profile}
          setProfile={setProfile}
          type={"resellers"}
        />
      )}

      <Divider my={8} />

      <CommunityChooser
        changingProfile={changingProfile}
        profile={profile}
        setProfile={setProfile}
        type={"organizations"}
      />
      <Divider my={8} />

      <CommunityChooser
        changingProfile={changingProfile}
        profile={profile}
        setProfile={setProfile}
        type={"teams"}
      />
    </Stack>
  );
};

export default CommunityManager;
